import { render, staticRenderFns } from "./TeachingImage.vue?vue&type=template&id=7a086e90&scoped=true&"
import script from "./TeachingImage.vue?vue&type=script&lang=js&"
export * from "./TeachingImage.vue?vue&type=script&lang=js&"
import style0 from "./TeachingImage.vue?vue&type=style&index=0&id=7a086e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a086e90",
  null
  
)

export default component.exports